
<p-inc-mail-menu-content
    :items         = "steps"
    :selected-item = "selected"
    :item-label    = "$t('mail.attachments.step')"
    item-text      = "name"
    :width         = "500"
    @search        = "onSearch"
    @selected      = "onStep"
>
    <template v-slot:item="{ item }">
        <div>
            {{ item.name }}
        </div>
    </template>
    <template v-slot:selection="{ item }">
        {{ item.name }}
    </template>

    <template v-slot:content>
        <div class="pa-3 pl-4 pr-1">
            <div class="mt-1">
                <p-inc-selectable-document
                    v-for     = "(document,index) in filteredDocuments"
                    :key      = "index"
                    :document = "document"
                    class     = "border-style"
                    :class    = "border(index)"
                    :selected = "isSelected(document)"
                    @selected = "onSelected"
                />

                <div  v-if="!filteredDocuments || filteredDocuments.length === 0" class="mail-empty-documents error--text">
                    {{ $t('mail.attachments.empty') }}
                </div>
            </div>
        </div>
    </template>
</p-inc-mail-menu-content>
